export type AccessRequestCategory = "brand" | "talent_management" | "creator";

const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "https://api.fitted.co";

/**
 * Sends a landing-site form to the Fitted API, where it shows up in the
 * app.fitted.co admin under Access Requests, labeled by `category`.
 * Empty strings are dropped so optional fields arrive as absent.
 */
export async function submitAccessRequest(
  category: AccessRequestCategory,
  fields: Record<string, string | string[] | undefined>
): Promise<void> {
  const body: Record<string, unknown> = { category };
  for (const [key, value] of Object.entries(fields)) {
    if (Array.isArray(value) ? value.length : value?.trim()) body[key] = value;
  }

  const res = await fetch(`${API_URL}/access-requests`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const message = Array.isArray(data?.message) ? data.message[0] : data?.message;
    throw new Error(
      typeof message === "string" && res.status === 400
        ? message.charAt(0).toUpperCase() + message.slice(1)
        : "Something went wrong. Please try again."
    );
  }
}

/** Reads a form's named text fields into a plain object. */
export function readForm(form: HTMLFormElement): Record<string, string> {
  const out: Record<string, string> = {};
  new FormData(form).forEach((value, key) => {
    if (typeof value === "string") out[key] = value;
  });
  return out;
}
